import "nexia_mobile/polyfills";
import "nexia_mobile/globals";
import "backbone";
import "nexia_mobile/raven_config";

import FastClick from "fastclick";
import "nexia_mobile/flux_like/action_handlers/all";
import Environment from "nexia_mobile/environment";
import LocalSettings from "nexia_mobile/models/local_settings";
import Dispatch from "nexia_mobile/flux_like/dispatch";
import Platform from "nexia_mobile/platform";
import QueryParams from "nx-components/QueryParams";
import UserAgent from "nx-components/UserAgent";
import patchBackboneSync from "nexia_mobile/patchBackboneSync";

patchBackboneSync();

const platform = QueryParams.platform();
const resetPasswordCode = QueryParams.resetPasswordCode();
const transferAccountCode = QueryParams.transferAccountCode();
if (platform === "ios-uiwebview" || platform === "ios-wkwebview") {
  // This forces iOS to process click events on non-clickable things, which
  // allows users to blur fields by tapping the background, etc.
  document.body.style.cursor = "pointer";
}

if (UserAgent.isAndroid()) {
  document.body.style.fontFamily = "Roboto, system-ui, sans-serif";
} else if (UserAgent.isIOS()) {
  document.body.style.fontFamily =
    "-apple-system, BlinkMacSystemFont, system-ui, sans-serif";
} else if (UserAgent.isWindows()) {
  document.body.style.fontFamily = '"Segoe UI", system-ui, sans-serif';
} else {
  document.body.style.fontFamily =
    "-apple-system, BlinkMacSystemFont, Roboto, system-ui, sans-serif";
}

if (platform === "ios-uiwebview") {
  FastClick.attach(document.body);
}

Platform.initScriptInterface(() => {
  LocalSettings.ensureBackwardsCompatibility();
  Dispatch("APP_LAUNCH");
  if (Environment.isCommercial() && resetPasswordCode) {
    Dispatch("APP_RESET_PASSWORD_CODE", resetPasswordCode);
  } else if (Environment.isCommercial() && transferAccountCode) {
    Dispatch("APP_TRANSFER_ACCOUNT_CODE", transferAccountCode);
  }
});



// WEBPACK FOOTER //
// ./src/main.js